export const RegisterSuccessfull = "RegisterSuccessfull"
export const RegisterRequest = "RegisterRequest"
export const RegisterFailure = "RegisterFailure"
export const LoginSuccessfull = "LoginSuccessfull"
export const LoginRequest = "LoginRequest"
export const LoginFailure = "LoginFailure"
export const LoginAgain="LoginAgain"
export const LogOut="LogOut"
